import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import {
    removeAuthToken,
    setLoggedUser,
    setUserRole,
    logoutUser
} from "../../redux/actions"

import axios from 'axios';


export default function TransferToChild(state) {
    const api = process.env.REACT_APP_API_URL;
    const dispatch = useDispatch();
    const history = useHistory();

    const loginUser = (result) => {
        localStorage.setItem('role', result.user_role);
        localStorage.setItem('authToken', result.access_token);
        localStorage.setItem('user', JSON.stringify(result));
        dispatch(setLoggedUser(result));
        dispatch(setUserRole(result.user_role));
    }
    useEffect(() => {
        // console.log(state.location.state.uid)
        // console.log(state.location.state.password)
        localStorage.removeItem('authToken');
        localStorage.removeItem('role');
        localStorage.removeItem('user');
        dispatch(logoutUser());
        dispatch(setUserRole(0))
        dispatch(removeAuthToken());
        dispatch(setLoggedUser(null));

        axios.post(`${api}/login_cp`, {
            pupil_id: state.location.state.uid,
            password: state.location.state.password

        }, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            // console.log(result)
            if (result.user) {
                loginUser(result);
                history.replace('/dashboard');
            }
        }).catch(error => {
            console.log(error);
        });

    }, [])
    return (
        <div className="mt-2 ml-2">
            Loggin in to child account....
        </div>
    )
}
